import axios from "axios";
import React, { useEffect, useState } from "react";

const ViewEvent = () => {

  const [events, setEvents] = useState([]);

  const [_id, setId] = useState("");
  const [name, setName] = useState("");
  const [categories, setCategories] = useState("");
  const [description, setDescription] = useState("");

  const [images, setImages] = useState([""]);

  const updateImage = (index, value) => {
    const updated = [...images];
    updated[index] = value;
    setImages(updated);
  };

  const addImage = () => {
    setImages([...images, ""]);
  };

  const removeImage = (index) => {
    if (images.length === 1) return;
    setImages(images.filter((_, i) => i !== index));
  };

  const updateLocation = (index, field, value) => {
    const updated = [...locations];
    updated[index][field] = value;
    setLocations(updated);
  };

  const addLocation = () => {
    setLocations([...locations, { city: "", state: "", venue: "", address: "" }]);
  };

  const removeLocation = (index) => {
    if (locations.length === 1) return;
    setLocations(locations.filter((_, i) => i !== index));
  };
  const updateContact = (field, value) => {
    setContact({ ...contact, [field]: value });
  };

  const [packages, setPackages] = useState([
    {
      eventName: "",
      packages: [
        {
          packageName: "",
          price: "",
          description: "",
          features: "",
          duration: ""
        }
      ]
    }
  ]);

  const [locations, setLocations] = useState([
    { city: "", state: "", venue: "", address: "" }
  ]);

  const [contact, setContact] = useState({
    name: "",
    phone: "",
    email: "",
    whatsapp: ""
  });

  useEffect(() => {
    fetchEvents();
  }, [])

  const fetchEvents = () => {
    axios.get("https://ezer-eventapp.onrender.com/events")
      .then(res => setEvents(res.data))
  }

  // GET EVENT

  const getOneRecord = (id) => {

    axios.get(`https://ezer-eventapp.onrender.com/events/${id}`)
      .then(res => {

        const data = res.data;

        setId(data._id);
        setName(data.name);
        setCategories(data.categories?.join(", ") || "");
        setDescription(data.description || "");

        setImages(data.images?.length ? data.images : [""]);

        setPackages(
          data.packages?.map(e => ({

            eventName: e.eventName,

            packages: e.packages.map(p => ({
              ...p,
              features: p.features?.join(", ") || ""
            }))

          })) || []
        );

        setLocations(data.locations?.length ? data.locations : []);

        setContact(data.contact || {});

      })

  }

  // UPDATE EVENT

  const updateEvent = (e) => {

    e.preventDefault();

    const payload = {

      name,

      categories: categories
        .split(",")
        .map(c => c.trim())
        .filter(Boolean),

      description,

      images: images.filter(Boolean),

      packages: packages.map(e => ({

        eventName: e.eventName,

        packages: e.packages.map(p => ({

          packageName: p.packageName,
          price: Number(p.price),
          description: p.description || "",
          features: p.features
            ? p.features.split(",").map(f => f.trim())
            : [],
          duration: p.duration || ""

        }))

      })),

      locations,

      contact

    }

    axios.put(`https://ezer-eventapp.onrender.com/events/${_id}`, payload)
      .then(() => {

        alert("Event updated");

        fetchEvents();

        document.body.classList.remove("modal-open");
        document.querySelectorAll(".modal-backdrop")
          .forEach(el => el.remove());

      })

  }

  const deleteEvent = (id) => {
    axios.delete(`https://ezer-eventapp.onrender.com/events/${id}`)
      .then(() => {
        setEvents(events.filter(e => e._id !== id))
      })
  }

  // EVENT TYPE FUNCTIONS

  const updateEventName = (i, value) => {
    const updated = [...packages];
    updated[i].eventName = value;
    setPackages(updated);
  }

  const addEventType = () => {
    setPackages([...packages, {
      eventName: "",
      packages: [{
        packageName: "",
        price: "",
        description: "",
        features: "",
        duration: ""
      }]
    }])
  }

  const removeEventType = (i) => {
    setPackages(packages.filter((_, index) => index !== i))
  }

  // PACKAGE FUNCTIONS

  const updatePackage = (eventIndex, packageIndex, field, value) => {
    const updated = [...packages];
    updated[eventIndex].packages[packageIndex][field] = value;
    setPackages(updated);
  }

  const addPackage = (eventIndex) => {
    const updated = [...packages];

    updated[eventIndex].packages.push({
      packageName: "",
      price: "",
      description: "",
      features: "",
      duration: ""
    });

    setPackages(updated);
  }

  const removePackage = (eventIndex, packageIndex) => {
    const updated = [...packages];
    updated[eventIndex].packages.splice(packageIndex, 1);
    setPackages(updated);
  }

  return (

    <div className="container py-5">

      <h2 className="text-center mb-5">Manage Events</h2>

      <div className="row">

        {events.map(event => (

          <div key={event._id} className="col-lg-6 mb-4">

            <div className="card shadow">

              <div className="card-body">

                <img
                  src={event.images?.[0]}
                  className="card-img-top"
                  style={{ height: "200px", objectFit: "cover" }}
                />

                <h4>{event.name}</h4>

                <p>{event.categories?.join(", ")}</p>

                <p>{event.description}</p>

                <h6>Packages</h6>

                {event.packages?.map((e, i) => (

                  <div key={i}>

                    <b>{e.eventName}</b>

                    {e.packages.map((p, j) => (

                      <div key={j}>

                        {p.packageName} - ₹{p.price}

                      </div>

                    ))}

                  </div>

                ))}

                <div className="mt-3">

                  <button
                    className="btn btn-primary me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#editModal"
                    onClick={() => getOneRecord(event._id)}
                  >
                    Edit
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() => deleteEvent(event._id)}
                  >
                    Delete
                  </button>

                </div>

              </div>

            </div>

          </div>

        ))}

      </div>

      {/* EDIT MODAL */}

      <div className="modal fade" id="editModal">

        <div className="modal-dialog modal-lg">

          <div className="modal-content">

            <div className="modal-header">

              <h5>Edit Event</h5>

              <button className="btn-close" data-bs-dismiss="modal"></button>

            </div>

            <div className="modal-body">

              <form onSubmit={updateEvent}>

                <input
                  className="form-control mb-3"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  placeholder="Event Name"
                />

                <input
                  className="form-control mb-3"
                  value={categories}
                  onChange={e => setCategories(e.target.value)}
                  placeholder="Categories"
                />

                <textarea
                  className="form-control mb-3"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  placeholder="Description"
                />

                <h5>Images</h5>

                {images.map((img, i) => (
                  <div key={i} className="d-flex gap-2 mb-2">

                    <input
                      className="form-control"
                      value={img}
                      placeholder="Image URL"
                      onChange={(e) => updateImage(i, e.target.value)}
                    />

                    {img && (
                      <img
                        src={img}
                        alt=""
                        style={{
                          width: "80px",
                          height: "60px",
                          objectFit: "cover",
                          borderRadius: "5px"
                        }}
                      />
                    )}

                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeImage(i)}
                    >
                      ❌
                    </button>

                  </div>
                ))}

                <button
                  type="button"
                  className="btn btn-secondary mb-3"
                  onClick={addImage}
                >
                  Add Image
                </button>

                <h5>Locations</h5>

                {locations.map((loc, i) => (

                  <div key={i} className="border p-3 mb-2">

                    <input
                      className="form-control mb-2"
                      value={loc.city}
                      placeholder="City"
                      onChange={(e) => updateLocation(i, "city", e.target.value)}
                    />

                    <input
                      className="form-control mb-2"
                      value={loc.state}
                      placeholder="State"
                      onChange={(e) => updateLocation(i, "state", e.target.value)}
                    />

                    <input
                      className="form-control mb-2"
                      value={loc.venue}
                      placeholder="Venue"
                      onChange={(e) => updateLocation(i, "venue", e.target.value)}
                    />

                    <input
                      className="form-control mb-2"
                      value={loc.address}
                      placeholder="Address"
                      onChange={(e) => updateLocation(i, "address", e.target.value)}
                    />

                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeLocation(i)}
                    >
                      Remove Location
                    </button>

                  </div>

                ))}

                <button
                  type="button"
                  className="btn btn-secondary mb-3"
                  onClick={addLocation}
                >
                  Add Location
                </button>

                <h5>Contact Details</h5>

                <input
                  className="form-control mb-2"
                  value={contact.name || ""}
                  placeholder="Contact Name"
                  onChange={(e) => updateContact("name", e.target.value)}
                />

                <input
                  className="form-control mb-2"
                  value={contact.phone || ""}
                  placeholder="Phone"
                  onChange={(e) => updateContact("phone", e.target.value)}
                />

                <input
                  className="form-control mb-2"
                  value={contact.email || ""}
                  placeholder="Email"
                  onChange={(e) => updateContact("email", e.target.value)}
                />

                <input
                  className="form-control mb-3"
                  value={contact.whatsapp || ""}
                  placeholder="Whatsapp"
                  onChange={(e) => updateContact("whatsapp", e.target.value)}
                />

                <h5>Event Packages</h5>

                {packages.map((e, i) => (

                  <div key={i} className="border p-3 mb-3">

                    <input
                      className="form-control mb-2"
                      value={e.eventName}
                      onChange={ev => updateEventName(i, ev.target.value)}
                      placeholder="Event Type"
                    />

                    {e.packages.map((p, j) => (

                      <div key={j} className="border p-2 mb-2">

                        <input
                          className="form-control mb-1"
                          value={p.packageName}
                          onChange={ev => updatePackage(i, j, "packageName", ev.target.value)}
                          placeholder="Package Name"
                        />

                        <input
                          className="form-control mb-1"
                          value={p.price}
                          onChange={ev => updatePackage(i, j, "price", ev.target.value)}
                          placeholder="Price"
                        />

                        <textarea
                          className="form-control mb-1"
                          value={p.description}
                          onChange={ev => updatePackage(i, j, "description", ev.target.value)}
                          placeholder="Description"
                        />

                        <input
                          className="form-control mb-1"
                          value={p.features}
                          onChange={ev => updatePackage(i, j, "features", ev.target.value)}
                          placeholder="Features"
                        />

                        <input
                          className="form-control mb-1"
                          value={p.duration}
                          onChange={ev => updatePackage(i, j, "duration", ev.target.value)}
                          placeholder="Duration"
                        />

                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => removePackage(i, j)}
                        >
                          Remove Package
                        </button>

                      </div>

                    ))}

                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => addPackage(i)}
                    >
                      Add Package
                    </button>

                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeEventType(i)}
                    >
                      Remove Event Type
                    </button>

                  </div>

                ))}

                <button
                  type="button"
                  className="btn btn-dark mb-3"
                  onClick={addEventType}
                >
                  Add Event Type
                </button>

                <button className="btn btn-primary w-100">
                  Update Event
                </button>

              </form>

            </div>

          </div>

        </div>

      </div>

    </div>

  )

}

export default ViewEvent;